/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddInteractionResponse
 */
export interface AddInteractionResponse {
    /**
     * 
     * @type {string}
     * @memberof AddInteractionResponse
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof AddInteractionResponse
     */
    interactionId: string;
}

/**
 * Check if a given object implements the AddInteractionResponse interface.
 */
export function instanceOfAddInteractionResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "interactionId" in value;

    return isInstance;
}

export function AddInteractionResponseFromJSON(json: any): AddInteractionResponse {
    return AddInteractionResponseFromJSONTyped(json, false);
}

export function AddInteractionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddInteractionResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
        'interactionId': json['interactionId'],
    };
}

export function AddInteractionResponseToJSON(value?: AddInteractionResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'interactionId': value.interactionId,
    };
}

